import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { contactsApi } from 'src/Services/API';

const MIN_QUERY_LENGTH = 3;

/** Active French companies matching `query` (public register, 5 results max). */
const useSearchCompanies = (query: string) => {
  const assetId = useCurrentAssetId();
  const trimmed = query.trim();

  return useQuery({
    queryKey: ['search-companies', assetId, trimmed.toLowerCase()],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return (await contactsApi.contactsControllerSearchCompanies(assetId, trimmed)).data;
    },
    enabled: !!assetId && trimmed.length >= MIN_QUERY_LENGTH,
    staleTime: 5 * 60 * 1000,
  });
};

export default useSearchCompanies;
